<!-- 由 suu 创建于 2020-06-10 星期三 -->
<template>
  <div class="yearCalendar">
    <div class="title title-img" v-if="getImg">
      <div class="cur-month">{{ curYear }}年</div>
    </div>
    <div class="title" v-else>
      <i class="el-icon-caret-left user-btn" @click="onLastYear"></i>
      <div class="cur-month">
        {{ curYear }}年
        <span v-if="curType == 0"
          >({{
            (course && (course.length || Object.keys(course).length)) || 0
          }}次)</span
        >
        <span v-if="curType == 1"
          >({{
            (training && (training.length || Object.keys(training).length)) ||
            0
          }}次)</span
        >
        <span v-if="curType == 2"
          >({{
            (food && (food.length || Object.keys(food).length)) || 0
          }}次)</span
        >
      </div>
      <i class="el-icon-caret-right user-btn" @click="onNextYear"></i>
    </div>
    <div
      :class="[
        getImg
          ? 'month-region month-region-img'
          : 'month-region month-region-nor'
      ]"
      v-for="(item, index) in 12"
      :key="index"
    >
      <div class="month-title">{{ index + 1 }}月</div>
      <div class="month-item">
        <div
          class="day-item"
          :class="getDayItem(index + 1, dayIndex + 1)"
          v-for="(dayItem, dayIndex) in getMonthDay(curYear, index)"
          :key="dayIndex"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'yearCalendar',

  components: {},

  props: {
    getImg: {
      type: Boolean,
      default: false
    },
    curType: {
      type: [String, Number],
      default: 0
    },
    course: {
      type: [Object, Array]
    },
    food: {
      type: [Object, Array]
    },
    training: {
      type: [Object, Array]
    }
  },

  data() {
    return {
      uid: this.$route.query.uid,
      curYear: new Date().getFullYear()
    }
  },

  computed: {},

  watch: {},

  created() {},

  mounted() {},

  destroyed() {},

  methods: {
    getDayItem(month, day) {
      let dayText = `${this.curYear}-${this.handleDate(
        month
      )}-${this.handleDate(day)}`
      switch (Number(this.curType)) {
        case 0:
          if (this.course && this.course[dayText]) {
            return 'day-item-course'
          }
          break
        case 1:
          if (this.training && this.training[dayText]) {
            return 'day-item-training'
          }
          break
        case 2:
          if (this.food && this.food[dayText]) {
            return 'day-item-food'
          }
          break
        default:
          break
      }
      return ''
    },
    getMonthDay(year, month) {
      let days = new Date(year, month + 1, 0).getDate()
      return days
    },
    // 处理月/日的显示格式
    handleDate(date) {
      // var d =date;
      // if (date.toString().length === 1) {
      //   d = "0" + date;
      // }
      // return d;
      return ('00' + date).slice(String(date).length)
    },
    onYearChange(flag = 0) {
      if (!flag) this.$toast.loading('加载中···')
      this.$http
        .get(
          'member/Poster?a=getStatistics',
          { uid: this.uid, ym: this.curYear },
          true
        )
        .then((res) => {
          this.$toast.clear()
          if (res.data.code === 200) {
            this.$emit('yearChange', res.data.data)
          } else {
            this.$dialog.alert({ mesaage: res.data.msg })
          }
        })
        .catch((err) => {
          this.$toast.clear()
          this.$dialog.alert({ message: '网络错误' })
        })
    },
    onNextYear() {
      if (this.curYear >= new Date().getFullYear()) return
      this.curYear = this.curYear + 1
      this.onYearChange()
    },
    onLastYear() {
      if (this.curYear <= 2019) return
      this.curYear = this.curYear - 1
      this.onYearChange()
    }
  }
}
</script>

<style lang="scss" scoped>
@function vw($px) {
  @return ($px / 375) * 100vw;
}
.yearCalendar {
  width: 100%;
  box-sizing: border-box;
  padding: 4vw 0;
  margin-top: 2.7vw;
  background-color: #fff;
  .title {
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: vw(4);
    color: #000;
    box-sizing: border-box;
    letter-spacing: vw(0.5);
    font-size: 5.3vw;
    font-weight: 450;
    // margin-top: 3.5vw;
    margin-bottom: 4.3vw;
    span {
      font-size: 3.7vw;
    }
  }
  .title > i {
    font-size: vw(16);
    color: #dc0050;
    margin: 0 5vw;
  }
  .month-region {
    width: 100%;
    padding-left: 6.4vw;
    padding-right: 5vw;
    box-sizing: border-box;
    margin-bottom: 1.5vw;
    .month-title {
      width: 8vw;
      text-align: right;
      font-size: 3.7vw;
      color: rgba(0, 0, 0, 0.5);
      margin-right: 3.7vw;
    }
    .month-item {
      flex: 1;
      display: flex;
      flex-wrap: wrap;
      // justify-content: space-between;
      box-sizing: border-box;
      .day-item {
        width: 3.7vw;
        height: 2.7vw;
        background-color: #f7f7f7;
        border: solid 0.3vw #f1f1f1;
        margin-bottom: 1.1vw;
        margin-right: 1.1vw;
        box-sizing: border-box;
      }
      .day-item-course {
        background-color: #ff77a3;
        border: solid 0.3vw #e55c88;
      }
      .day-item-training {
        background-color: #abe7ff;
        border: solid 0.3vw #83c2da;
      }
      .day-item-food {
        background-color: #ffe8aa;
        border: solid 0.3vw #ffd04e;
      }
    }
  }
  .month-region-nor {
    display: flex;
  }
  // 生成图片时
  .title-img {
    background-color: #eef0f3;
    border-radius: 1.3vw;
    width: 82.9vw;
    height: 6.4vw;
    font-size: 4.8vw;
    font-weight: 550;
    padding: 0;
    margin: 0 auto;
    margin-bottom: 3vw;
  }
  .month-region-img {
    .month-title {
      font-size: 3.5vw;
      color: #000;
      font-weight: 550;
      margin-bottom: 1.5vw;
    }
  }
}
</style>
